import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  MOBILE_BREAKPOINT_IN_PX,
  TABLET_BREAKPOINT_IN_PX,
} from '../../constants';

const Description = styled.div`
  margin-top: 20px;
  margin-bottom: 35px;

  @media screen and (max-width: ${TABLET_BREAKPOINT_IN_PX}px) {
    margin-bottom: 15px;
  }

  @media screen and (max-width: ${MOBILE_BREAKPOINT_IN_PX}px) {
    padding-left: 20px;
    padding-right: 20px;
    margin-bottom: 0;
  }
`;

const Disclaimer = styled.div`
  @media screen and (max-width: ${MOBILE_BREAKPOINT_IN_PX}px) {
    padding-left: 20px;
    padding-right: 20px;
  }
`;

const RegionDecription = ({ description, disclaimer }) => (
  <div>
    <Description>{description}</Description>
    <Disclaimer>{disclaimer}</Disclaimer>
  </div>
);

RegionDecription.propTypes = {
  description: PropTypes.node,
  disclaimer: PropTypes.node.isRequired,
};

RegionDecription.defaultProps = {
  description: null,
};

export default RegionDecription;
